import { useTradeWayLabel } from 'components/secondaryMarket/shared/status/tradeWay';
import { ListGroup, ListGroupItem } from 'components/shared/ListGroup';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { LimitValidity, OrderType } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.model';
import { DlpOrderStatus } from 'state/secondaryMarket/dlpOrder/order/order.model';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';

export interface OrderPlacedDetailsProps {
  orderId: string;
  tradeWay: TradeWay;
  isin: string;
  orderType: OrderType;
  validity?: LimitValidity;
  status: DlpOrderStatus;
}

export const OrderPlacedDetails: FC<OrderPlacedDetailsProps> = ({
  orderId,
  tradeWay,
  isin,
  orderType,
  validity,
  status,
}) => {
  const tradeWayLabel = useTradeWayLabel({ way: tradeWay });
  const { formatMessage } = useIntl();
  return (
    <ListGroup className="h-100 overflow-y-auto">
      <ListGroupItem
        className="ps-0 pe-3 text-nowrap"
        labelKey="secondaryMarket.sidePanel.label.orderId"
        data-e2e="orderId"
      >
        <span data-e2e="orderId-value" className="ms-3" title={orderId}>
          {orderId}
        </span>
      </ListGroupItem>
      {status === 'ORDER_PLACED' && (
        <>
          <ListGroupItem
            className="ps-0 pe-3"
            labelKey="secondaryMarket.sidePanel.label.tradeSide"
            data-e2e="tradeSide"
          >
            <span data-e2e="tradeSide-value">{tradeWayLabel}</span>
          </ListGroupItem>
          <ListGroupItem className="ps-0 pe-3" labelKey="secondaryMarket.sidePanel.label.isin" data-e2e="isin">
            <span data-e2e="tradeSide-value">{isin}</span>
          </ListGroupItem>
          <ListGroupItem
            className="ps-0 pe-3"
            labelKey="secondaryMarket.sidePanel.label.orderType"
            data-e2e="orderType"
          >
            <span data-e2e="tradeSide-value">{orderType}</span>
          </ListGroupItem>
          {validity && (
            <ListGroupItem
              className="ps-0 pe-3"
              labelKey="secondaryMarket.sidePanel.label.validity"
              data-e2e="validity"
            >
              <span data-e2e="tradeSide-value">
                {formatMessage({ id: `secondaryMarket.sidePanel.label.validity.${validity}` })}
              </span>
            </ListGroupItem>
          )}
        </>
      )}
    </ListGroup>
  );
};
